import React from "react";

import {Types} from "components";

import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import SignatureCanvas from "react-signature-canvas";
import {Button} from "reactstrap";
import moment from "moment";
import ObjectOverride from "components/ObjectOverride";


/**
 *  @property {Dispositions_Pendings_Object} state
 *  @property {object} model
 *  @property {Dispositions_Pendings_Properties} model.properties
 *  @property {Dispositions_Pendings_Is} model.is
 *  @property {Dispositions_Pendings_Has} model.has
 */
export default class AccountSign extends ObjectOverride {
	constructor(props) {
		super(props, Types.Accounts_Customizations._name);
		this.state.sigWidth = null;
	}

	/** @type Object */
	sigPad = null;
	clear = (sigPad) => () => {
		this[sigPad].clear();
	};

	componentDidMount(prevProps, prevState, snapshot) {
		super.componentDidMount(prevProps, prevState, snapshot)
		this.setSigPadWidth();
	}

	// noinspection JSUnusedLocalSymbols
	handleProcess(event, requestOverride) {
		this.state.account_signature = this.sigPad.getCanvas().toDataURL('image/png');
		return true;
	}

	async handleSubmit() {
		this.handleProcess(null, null);
		this.props.afterSave({
			account_signature: this.state.account_signature
		})
	}

	setSigPadWidth = () => {
		let scrollbarWidth = 17; //Based on Google Chrome, can detect different browsers if necessary
		let viewportWidth = window.innerWidth - scrollbarWidth;
		const styledPaddingAndPositioning = ((15 + 14 + 40) * 2)

		let breakpointXsmSmCalc = () => viewportWidth - styledPaddingAndPositioning;
		let breakpointMdCalc = () => viewportWidth * 0.65 - styledPaddingAndPositioning;
		let breakpointLgXlgCalc = () => (viewportWidth * 0.65 - 15 * 2 - 14 * 2) * 0.7 - 40 * 2;
		let first = window.innerWidth < 769 ? breakpointXsmSmCalc()
			: window.innerWidth < 992 ? breakpointMdCalc()
				: breakpointLgXlgCalc();
		if (this.state.sigWidth !== first || !this.state.sigWidth) {
			return first;
		}
		return 100;
	}

	form = () => {
		return (
			<div>
				{this.props.noShowSigText ? null :
					<p style={{textAlign: 'center'}}>
						<b>
							Saving this signature will delete your old one
						</b>
					</p>}
				<div className={'row'}>
					<div style={{width: '100%'}}>
						<Card style={{display: 'flex', flexDirection: 'column'}}>
							<CardContent style={{display: 'flex', width: '100%'}}>
								<span className={'signature'}/>
								<div style={{backgroundColor: '#f2f3f4'}}>
								<SignatureCanvas penColor='black' minWidth={3}
								                 canvasProps={{width: this.setSigPadWidth(), height: 300, className: 'sigCanvas'}}
								                 ref={ref => this.sigPad = ref}/>
								</div>
							</CardContent>
							<hr/>
							<CardActions style={{paddingTop: 0}}>
								<Button color="secondary" onClick={this.clear('sigPad')}>Clear</Button>
							</CardActions>
						</Card>
					</div>
				</div>
			</div>
		)
	};

}

